import React, { useEffect, useState } from "react";
import * as signalR from "@microsoft/signalr";
import { API_BASE_URL, HUB_URL } from "../../apiConfig";

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);

  // 1️⃣ Load notifications from DB
  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const authToken = localStorage.getItem("authToken");
        if (!authToken) return;

        const response = await fetch(`${API_BASE_URL}/Notifications/admin`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${authToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          console.error("Failed to fetch notifications");
          return;
        }

        const data = await response.json();
        setNotifications(data);
      } catch (error) {
        console.error("Error loading notifications:", error);
      }
    };

    fetchNotifications();
  }, []);

  // 2️⃣ SignalR live notifications
  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    if (!authToken) return;

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(HUB_URL, {
        accessTokenFactory: () => authToken,
      })
      .withAutomaticReconnect()
      .build();

    connection.start().catch(err => console.error("SignalR error:", err));

    connection.on("NewNotification", (data) => {
      setNotifications(prev => [
        {
          ...data,
          isRead: false,
        },
        ...prev,
      ]);
    });

    return () => connection.stop();
  }, []);

  useEffect(() => {
    const handleNotificationRead = (event) => {
      const { id } = event.detail;
      setNotifications(prev => {
        const item = prev.find(n => n.notificationId === id);
        if (item && item.isRead) return prev;
        return prev.map(n => n.notificationId === id ? { ...n, isRead: true } : n);
      });
    };

    window.addEventListener("notificationRead", handleNotificationRead);
    return () => window.removeEventListener("notificationRead", handleNotificationRead);
  }, []);

  // 3️⃣ Mark as read
  const markAsRead = async (id) => {
    setNotifications(prev =>
      prev.map(n =>
        n.notificationId === id ? { ...n, isRead: true } : n
      )
    );

    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) return;

      const response = await fetch(`${API_BASE_URL}/Notifications/mark-read/${id}`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      });

      if (response.ok) {
        window.dispatchEvent(new CustomEvent("notificationRead", { detail: { id } }));
      } else {
        console.error("Failed to mark as read in DB");
      }
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card card-default">
            <div className="card-header">
              <h2 className="card-title">Notifications</h2>
              <p className="text-muted">View all your notifications</p>
            </div>

            <div className="card-body">
              {notifications.length > 0 ? (
                <div className="notification-list">
                  {notifications.map((notification, index) => (
                    <div
                      key={index}
                      onClick={() => markAsRead(notification.notificationId)}
                      className={`notification-item border-bottom p-3 ${!notification.isRead ? "bg-light" : ""
                        }`}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="d-flex align-items-start">
                        <div className="notification-icon mr-3">
                          <i className="mdi mdi-bell-outline h5"></i>
                        </div>

                        <div className="notification-content flex-grow-1">
                          <h5 className="notification-title mb-2">
                            {notification.retailerName}
                          </h5>

                          <p className="notification-message text-muted mb-2">
                            {notification.message}
                          </p>

                          <small className="notification-time text-secondary">
                            <i className="mdi mdi-clock-outline"></i>{" "}
                            {new Date(notification.createdAt).toLocaleString()}
                          </small>
                        </div>

                        {!notification.isRead && (
                          <div className="notification-badge ml-2">
                            <span className="badge badge-primary">New</span>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-5">
                  <i className="mdi mdi-bell-off h2 text-muted"></i>
                  <p className="text-muted mt-3">No notifications yet</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notifications;

// import React, { useState } from 'react';

// const Notifications = () => {
//   const [notifications] = useState([
//     {
//       id: 1,
//       name: 'Aaren',
//       message: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nam itaque doloremque odio, eligendi delectus vitae.',
//       time: '30 min ago',
//       icon: 'mdi-account-plus',
//       read: false
//     },
//     {
//       id: 2,
//       name: 'Abril',
//       message: 'Donec mattis augue a nisl consequat, nec imperdiet ex rutrum. Fusce et vehicula enim. Sed in enim eu odio vehic.',
//       time: 'Just now',
//       icon: 'mdi-alert',
//       read: true
//     },
//     {
//       id: 3,
//       name: 'Emma',
//       message: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nam itaque doloremque odio, eligendi delectus vitae.',
//       time: '1 hrs ago',
//       icon: 'mdi-information',
//       read: false
//     },
//     {
//       id: 4,
//       name: 'New user registered',
//       message: 'A new user has successfully registered on the platform.',
//       time: '2 hrs ago',
//       icon: 'mdi-account-plus',
//       read: false
//     },
//     {
//       id: 5,
//       name: 'User deleted',
//       message: 'A user account has been deleted from the system.',
//       time: '3 hrs ago',
//       icon: 'mdi-account-remove',
//       read: true
//     },
//     {
//       id: 6,
//       name: 'Sales report is ready',
//       message: 'Your monthly sales report is now available for download.',
//       time: '4 hrs ago',
//       icon: 'mdi-chart-areaspline',
//       read: false
//     },
//     {
//       id: 7,
//       name: 'New client',
//       message: 'A new client has been added to your account.',
//       time: '5 hrs ago',
//       icon: 'mdi-account-supervisor',
//       read: true
//     },
//     {
//       id: 8,
//       name: 'Server overloaded',
//       message: 'The server is experiencing high load. Please monitor the system.',
//       time: '6 hrs ago',
//       icon: 'mdi-server-network-off',
//       read: false
//     }
//   ]);

//   return (
//     <div className="container-fluid">
//       <div className="row">
//         <div className="col-12">
//           <div className="card card-default">
//             <div className="card-header">
//               <h2 className="card-title">Notifications</h2>
//               <p className="text-muted">View all your notifications</p>
//             </div>

//             <div className="card-body">
//               {notifications.length > 0 ? (
//                 <div className="notification-list">
//                   {notifications.map((notification) => (
//                     <div
//                       key={notification.id}
//                       className={`notification-item border-bottom p-3 ${!notification.read ? 'bg-light' : ''}`}
//                     >
//                       <div className="d-flex align-items-start">
//                         <div className="notification-icon mr-3">
//                           <i className={`mdi ${notification.icon} h5`}></i>
//                         </div>
//                         <div className="notification-content flex-grow-1">
//                           <h5 className="notification-title mb-2">{notification.name}</h5>
//                           <p className="notification-message text-muted mb-2">
//                             {notification.message}
//                           </p>
//                           <small className="notification-time text-secondary">
//                             <i className="mdi mdi-clock-outline"></i> {notification.time}
//                           </small>
//                         </div>
//                         {!notification.read && (
//                           <div className="notification-badge ml-2">
//                             <span className="badge badge-primary">New</span>
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               ) : (
//                 <div className="text-center py-5">
//                   <i className="mdi mdi-bell-off h2 text-muted"></i>
//                   <p className="text-muted mt-3">No notifications yet</p>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Notifications;
